import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext(null);
const KEY = "ninjavity_wishlist";

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [codes, setCodes] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const synced = useRef(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(codes)); }, [codes]);

  useEffect(() => {
    if (!user) { synced.current = false; return; }
    api.get("/wishlist").then((r) => {
      const merged = [...new Set([...r.data.codes, ...codes])];
      setCodes(merged);
      synced.current = true;
      if (merged.length !== r.data.codes.length) api.put("/wishlist", { codes: merged }).catch(() => {});
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const persist = useCallback((next) => { if (user && synced.current) api.put("/wishlist", { codes: next }).catch(() => {}); }, [user]);

  const toggle = useCallback((code) => {
    let added = false;
    setCodes((prev) => { added = !prev.includes(code); const next = added ? [...prev, code] : prev.filter((c) => c !== code); persist(next); return next; });
    return added;
  }, [persist]);
  const has = useCallback((code) => codes.includes(code), [codes]);
  const addMany = useCallback((list) => setCodes((prev) => { const next = [...new Set([...prev, ...list])]; persist(next); return next; }), [persist]);

  const value = useMemo(() => ({ codes, count: codes.length, toggle, has, addMany }), [codes, toggle, has, addMany]);
  return <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>;
};

export const useWishlist = () => useContext(WishlistContext);
